/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_Col_FeatureInputs */

const en_mk_mx_col_feature = /** @type {(inputs: Mk_Mx_Col_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature`)
};

const id_mk_mx_col_feature = /** @type {(inputs: Mk_Mx_Col_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitur`)
};

/**
* | output |
* | --- |
* | "Feature" |
*
* @param {Mk_Mx_Col_FeatureInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_col_feature = /** @type {((inputs?: Mk_Mx_Col_FeatureInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_Col_FeatureInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_col_feature(inputs)
	return en_mk_mx_col_feature(inputs)
});